
import {
  defineComponent,
  computed,
  ref,
  useContext,
} from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ProductPreviewInformation',
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    productDocuments: {
      type: Array,
      default: () => [],
    },
    productUserGuides: {
      type: Array,
      default: () => [],
    },
    isLoadingDocuments: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { i18n } = useContext();
    const isShowDocuments = ref(true);
    const modal = ref(null);
    const currentModalTitle = computed(() =>
      isShowDocuments.value ? i18n.t('documentation') : i18n.t('video_guide')
    );

    const currentModalLinkIcon = computed(() =>
      isShowDocuments.value ? 'document' : 'youtube'
    );

    const currentModalData = computed(() =>
      isShowDocuments.value ? props.productDocuments : props.productUserGuides
    );

    const bulletsList = computed(() =>
      props?.product?.content.find((el) => el.type === 'bullets')
    );

    const handleDocumentsButton = () => {
      isShowDocuments.value = true;
      modal.value.open();
    };

    const handleVideoButton = () => {
      isShowDocuments.value = false;
      modal.value.open();
    };

    return {
      bulletsList,
      modal,
      currentModalData,
      currentModalTitle,
      currentModalLinkIcon,
      handleDocumentsButton,
      handleVideoButton,
    };
  },
});
